import { useSelector } from 'react-redux';
import {
    ChannelTheme,
    ChannelType,
    getActiveScreen,
    getActiveStore,
} from 'src/modules/Redux';
import {
    getChannelOptions,
    getDefaultBgColor,
    getDefaultProductNameTextColor,
    getDefaultProductPriceTextColor,
    getDefaultTileBgColor,
} from './utils';
import { useTileSize } from './hooks/useTileSize';
import { useSortProducts } from './hooks/useSortProducts';
import { useEffect, useState } from 'react';
import { Container, LoadingIndicator } from 'src/ui/components';
import { useWindowSize } from '../CustomerPickupScreen/hooks/useWindowSize';
import { Tile } from './components/Tile';

function App() {
    const tileSize = useTileSize();

    const screen = useSelector(getActiveScreen);
    const options = getChannelOptions(ChannelType.InfiniteScrollImage, screen);

    const theme = options.getOrDefault('theme', ChannelTheme.LIGHT);

    const sortedProducts = useSortProducts();

    const bgColor = options.getOrDefault(
        'menuBoardBackgroundColor',
        getDefaultBgColor(theme)
    );
    const priceColor = getDefaultProductPriceTextColor(theme);
    const textColor = getDefaultProductNameTextColor(theme);

    const tileColor = options.getOrDefault(
        'productBackgroundColor',
        getDefaultTileBgColor(theme)
    );

    const fontSize = Math.floor(tileSize / 18);
    return (
        <div
            className="w-screen h-screen items-center justify-center flex flex-wrap"
            style={{
                backgroundColor: bgColor,
                paddingTop: '2.5%',
                paddingBottom: '2.5%',
                paddingLeft: '2.5%',
                paddingRight: '2.5%',
                fontSize,
            }}
        >
            {sortedProducts.map((item, i) => (
                <Tile
                    key={i}
                    item={item}
                    tileSize={tileSize}
                    tileColor={tileColor || ''}
                    textColor={textColor}
                    priceColor={priceColor}
                />
            ))}
        </div>
    );
}

export function MenuBoard() {
    const [loading, setLoading] = useState(true);
    const activeScreen = useSelector(getActiveScreen);
    const activeStore = useSelector(getActiveStore);
    const windowSize = useWindowSize();

    // this loader prevents menu board from being rendered 30 times
    // (which can be expensive due to the auto tile size calculation )
    // in the first 3 seconds of the app starting up. unable to find the source of the re-renders,
    // but this will prevent the UI from flickering or crashing.
    useEffect(() => {
        setLoading(true);
        const timer = setTimeout(() => {
            setLoading(false);
        }, 3000);

        return () => clearTimeout(timer);
    }, [activeScreen, activeStore, windowSize]);

    if (loading) {
        return (
            <Container>
                <LoadingIndicator />
            </Container>
        );
    }

    return <App />;
}
